import React, { useState, useEffect } from 'react'
import Modal from 'react-modal'
import { Table, NoContentBox } from '@enkla-gui'

export default function SearchModal({ search, buttons, hiddenSearch, open, close, callback, children, title = 'Sök' }) {
	const [results, setResults] = useState([])
	const [searching, setSearching] = useState(false)
	const [query, setQuery] = useState('')

	useEffect(() => {
		setResults([])
		if (query.trim().length === 0) {
			setResults([])
			setSearching(false)
			return
		}
		if (!query.length !== 0 && !searching) setSearching(true)
		const timeoutId = setTimeout(() => dispatch(query), 500)
		return () => clearTimeout(timeoutId)
	}, [query])

	const dispatch = function(query) {
		search(query)
			.then(response => {
				setSearching(false)
				setResults(response.hits)
			})
			.catch(error => {
				setResults([])
				setSearching(false)
			})
	}

	return (
		<Modal
			isOpen={open}
			onRequestClose={() => {
				close()
				setResults([])
				setSearching(false)
				setQuery('')
			}}
			className='card' >
			<div class='card-body modal-body' style={{ 'background': '#fff' }}>
				{children}
				<div class='form-group' hidden={hiddenSearch}>
					<input type='text' class='form-control' placeholder='Sök...' onChange={e => setQuery(e.target.value)} />
				</div>
				{results.length !== 0 && !hiddenSearch && (
					<div class='navbar-search-results modal-search-results'>
						<small class="fst-italic">Visar de {results?.hits.length} mest exakta träffarna</small>
						<div class='search-clear-results' onClick={e => setResults([])} />
						<div class='card-body'>
							{!!results?.total?.value && (
								<Table
									rows={results.hits}
									functions={{
										type: data => (
											<div class='icon-badge'>
												<i class={`fas fa-fw ${data.icon}`} /> <span>{data.type}</span>{' '}
											</div>
										),
										title: data => (
											<span>
												<i class={'fas fa-fw ' + data.icon} /> {data.title}
											</span>
										),
										return: value => {
											return (
												<button
													onClick={() => {
														callback(value)
														setResults([])
													}}
													class='btn btn-primary btn-sm text-light mr-5'>
													<i class='fas fa-plus' /> Välj
												</button>
											)
										}
									}}
									keys={['_this>function:return', '_source.render.title', '_source.render>function:type']}>
									<th class='min'></th>
									<th></th>
									<th class='min'></th>
								</Table>
							)}
							{results.total?.value === 0 && <NoContentBox text='Inga resultat' icon='fa-info-circle' />}
						</div>
					</div>
				)}
				{searching && (
					<div class='navbar-search-results' onClick={e => setResults([])}>
						<div class='search-clear-results' />
						<div class='no-padding'>
							<NoContentBox text='Söker...' icon='fa-circle-notch fa-spin' />
						</div>
					</div>
				)}
			</div>
			{results.length === 0 && !searching && !hiddenSearch && <NoContentBox text={title} icon='fa-search' />}
			<div class='card-buttons'>
				<button
					class='btn btn-light'
					onClick={() => {
						close()
						setResults([])
					}}>
					Avbryt
				</button>
				{buttons && buttons}
			</div>

		</Modal>
	)
}
